<template>
    <div>
        <div class="is-pc swiper-container-news">
            <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow recommend">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(newsItem, index) in pcNewsList" :key=index>
                    <a :href="newsItem.url">
                        <div class="c-slider-news__img">
                            <img :src="newsItem.thumb_nail" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ newsItem.title }}</p>
                                <div v-if="newsItem.new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                        {{ newsItem.show_date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow recommend">
        </div>
        <div class="is-sp carousel-sp recommend-news-carousel-sp">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(newsItem, index) in spNewsList" :key=index>
                    <a :href="newsItem.url">
                        <div class="c-slider-news__img">
                            <img :src="newsItem.thumb_nail" alt="">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ newsItem.title }}</p>
                                <div v-if="newsItem.new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                        {{ newsItem.show_date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import Swiper from 'swiper/bundle';
import axios from 'axios';
import moment from "moment";
export default {
    props: {
        route_list: Object,
        recommend_categories: Array,
        recommend_from : String,
        recommender_string: String,
        number_of_result: String,
    },
    mixins: [routeMixin],
    data(){
        return{
            newsLists: []
        }
    },
    async mounted() {
        await this.makeData();

        this.$nextTick(() => {
            // 3項目のため、専用のswiperを用意する
            const swiper = new Swiper('.swiper-container-news', {
                freeMode: {
                    enabled: true,
                    momentumBounce: true,
                },
                slidesPerView: 3,
                navigation: {
                    nextEl: ".next-arrow.recommend",
                    prevEl: ".prev-arrow.recommend",
                },
            });

            const carouselSp = new Swiper('.recommend-news-carousel-sp', {
                freeMode: {
                    enabled: true,
                    momentumBounce: true,
                },
                slidesPerView: 2.5,
            });
        });
    },
    computed: {
        pcNewsList: function() {
            return this.newsLists.slice(0,4);
        },
        spNewsList: function() {
            return this.newsLists.slice(0,4);
        }
    },
    methods:{
        getData: async function(){
            let url = this.route(this.route_list, 'site.api.recommender');;
            let newsLists = [];
            let params = {
                params: {
                    recommend_from : this.recommend_from,
                    recommender_string : this.recommender_string,
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }
            let fall_back_param = {
                params: {
                    recommender_string : 'mostviewed',
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }
            if (!this.recommend_from) {
                params = fall_back_param
            }

            let done = false;
            await axios.get(url, params)
            .then(res => {
                newsLists = res.data;
                done = true;
            }).catch(error => {

            });

            if (done && newsLists.length === 0) {
                await axios.get(url, fall_back_param
                ).then(res => {
                    newsLists = res.data;
                }).catch(error => {

                });
            }

            return newsLists;
        },
        makeData: async function(){
            let newsLists = await this.getData();

            newsLists.forEach(function(recommend){
                // Newフラグの付与を行う
                recommend.new = false;
                if(recommend.pub_date !== null) {
                    let startDate = moment(recommend.pub_date);
                    let lastDate = moment().subtract(7, 'days').startOf('days');
                    recommend.show_date = startDate.format('Y年M月D日');
                    console.log(recommend.show_date)
                    if(startDate.isAfter(lastDate)) {
                        recommend.new = true;
                    }
                }

                // TODO:表示用の日付加工
            });

            this.newsLists = newsLists;
        },
    }
}
</script>

<style scoped>
.swiper-container-news {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.carousel-sp {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.c-lead-bold {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
}
</style>
